module.exports = __webpack_public_path__ + "img/sty_1.939824f2.png";